import { useRouterState } from "@tanstack/react-router";
import { useDeferredValue } from "react";

export function PageTitle() {
	const title = useRouterState({
		select: (s) => {
			const route = s.matches.at(-1);
			const metaTitle = route?.meta?.find(
				(m): m is { title: string } =>
					typeof m === "object" &&
					m !== null &&
					"title" in m &&
					typeof m.title === "string",
			)?.title;
			return metaTitle?.split(" - ")[0] ?? "Dashboard";
		},
	});

	const deferredTitle = useDeferredValue(title);

	return <h1 className="text-3xl font-bold">{deferredTitle}</h1>;
}
